(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["campaign-home"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-campaign-gallery]');
    if (!root) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-campaign-slide]'));
    var dots = Array.prototype.slice.call(document.querySelectorAll('[data-campaign-dot]'));
    var previous = document.querySelector('[data-campaign-previous]');
    var next = document.querySelector('[data-campaign-next]');
    var current = 0;

    function show(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === current); });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === current);
        dot.setAttribute('aria-current', i === current ? 'true' : 'false');
      });
    }

    previous.addEventListener('click', function () { show(current - 1); });
    next.addEventListener('click', function () { show(current + 1); });
    dots.forEach(function (dot, i) { dot.addEventListener('click', function () { show(i); }); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    // Submitting the sort form reloads with the chosen sort_by while active
    // filter params are preserved via hidden inputs.
    document.querySelectorAll('[data-sort-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var form = select.closest('[data-sort-form]');
        if (form) form.submit();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Sticky header behaviour: shadow past a small threshold, and slide out of
  // view on scroll-down / back in on scroll-up. Scroll work is rAF-throttled so
  // it stays smooth on mobile. Respects prefers-reduced-motion (no slide).
  (function () {
    var header = document.querySelector('.shopify-section-group-header-group');
    if (!header) return;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var SHADOW_AT = 50; // px scrolled before the shadow shows
    var HIDE_AT = 80; // don't slide away until at least this far down
    var lastY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var ticking = false;

    function update() {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;

      header.classList.toggle('ga-header--scrolled', y > SHADOW_AT);

      if (!reduceMotion) {
        var goingDown = y > lastY;
        // Keep the header visible while the mobile menu is open.
        var menuOpen = !!header.querySelector('.ga-header__disclosure[open]');
        if (goingDown && y > HIDE_AT && !menuOpen) {
          header.classList.add('ga-header--hidden');
        } else if (!goingDown) {
          header.classList.remove('ga-header--hidden');
        }
      }

      // Guard against negative overscroll bounce on iOS.
      lastY = y < 0 ? 0 : y;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });

    update(); // set correct state if the page loads already scrolled
  })();

  (function () {
    var cartIcon = document.querySelector('[data-cart-icon]');
    if (!cartIcon) return;

    cartIcon.addEventListener('click', function (e) {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('cart:open'));
    });

    // Quick scale pulse on the cart icon after "Lisää ostoskoriin".
    // Skipped under reduced motion.
    window.gaBumpCartIcon = function () {
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion) return;
      cartIcon.classList.remove('is-bumping');
      // Force reflow so the animation restarts on rapid repeat clicks.
      void cartIcon.offsetWidth;
      cartIcon.classList.add('is-bumping');
      window.setTimeout(function () {
        cartIcon.classList.remove('is-bumping');
      }, 320);
    };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var cta = document.querySelector('.ga-hero__cta[data-scroll-target]');
    if (!cta) return;

    cta.addEventListener('click', function (e) {
      var target = document.getElementById(cta.dataset.scrollTarget);
      if (!target) return;
      e.preventDefault();

      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  (function () {
    // Countdown to a fixed instant. The target is parsed as an absolute epoch
    // (the editor value carries a UTC offset, e.g. ...+03:00), and compared
    // against Date.now(), also absolute — so the remaining time is identical for
    // every visitor regardless of their local timezone. Reduced motion needs no
    // special handling: this only swaps text content, it never animates.
    document.querySelectorAll('[data-countdown]').forEach(function (root) {
      var targetMs = Date.parse(root.getAttribute('data-target'));
      var timer = root.querySelector('[data-countdown-timer]');
      var done = root.querySelector('[data-countdown-done]');
      var dEl = root.querySelector('[data-days]');
      var hEl = root.querySelector('[data-hours]');
      var mEl = root.querySelector('[data-minutes]');
      var sEl = root.querySelector('[data-seconds]');

      // Misconfigured / unparseable date: hide the countdown entirely rather
      // than show "--" forever.
      if (isNaN(targetMs)) {
        root.hidden = true;
        return;
      }

      function pad(n) {
        return (n < 10 ? '0' : '') + n;
      }

      var interval = null;
      function render() {
        var diff = targetMs - Date.now();
        if (diff <= 0) {
          if (timer) timer.hidden = true;
          if (done) done.hidden = false;
          if (interval) clearInterval(interval);
          return;
        }
        var total = Math.floor(diff / 1000);
        var days = Math.floor(total / 86400);
        total -= days * 86400;
        var hours = Math.floor(total / 3600);
        total -= hours * 3600;
        var minutes = Math.floor(total / 60);
        var seconds = total - minutes * 60;

        if (dEl) dEl.textContent = days;
        if (hEl) hEl.textContent = pad(hours);
        if (mEl) mEl.textContent = pad(minutes);
        if (sEl) sEl.textContent = pad(seconds);
      }

      render();
      interval = setInterval(render, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    // Scroll-snap carousel: native swipe on touch; arrows/dots drive it via
    // scrollTo. Active index derives from the track's scroll position.
    function slideWidth(track) {
      var slide = track.querySelector('.ga-product__slide');
      return slide ? slide.getBoundingClientRect().width : track.clientWidth;
    }
    function currentIndex(track) {
      var w = slideWidth(track);
      return w ? Math.round(track.scrollLeft / w) : 0;
    }
    // Update dots + arrow disabled state. Pass an explicit index to reflect a
    // target immediately (on click), or omit it to derive the index from the
    // track's current scroll position (on the scroll event).
    function syncControls(carousel, forcedIndex) {
      var track = carousel.querySelector('.ga-product__track');
      if (!track) return;
      var slides = carousel.querySelectorAll('.ga-product__slide');
      var dots = carousel.querySelectorAll('.ga-product__dot');
      var prev = carousel.querySelector('.ga-product__arrow--prev');
      var next = carousel.querySelector('.ga-product__arrow--next');
      var max = slides.length - 1;
      var index = typeof forcedIndex === 'number' ? forcedIndex : currentIndex(track);
      if (index < 0) index = 0;
      if (index > max) index = max;

      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= max;
    }
    function scrollToIndex(carousel, index) {
      var track = carousel.querySelector('.ga-product__track');
      if (!track) return;
      var max = carousel.querySelectorAll('.ga-product__slide').length - 1;
      if (index < 0) index = 0;
      if (index > max) index = max;
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({ left: index * slideWidth(track), behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    document.querySelectorAll('.ga-product__carousel[data-product-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('.ga-product__track');
      if (!track) return;
      syncControls(carousel);
      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          syncControls(carousel);
        });
      }, { passive: true });
    });

    document.addEventListener('click', function (e) {
      var control = e.target.closest(
        '[data-product-carousel-prev], [data-product-carousel-next], [data-product-carousel-dot]'
      );
      if (!control) return;
      var carousel = control.closest('.ga-product__carousel');
      if (!carousel) return;
      e.preventDefault();

      var track = carousel.querySelector('.ga-product__track');
      var slides = carousel.querySelectorAll('.ga-product__slide');
      var max = slides.length - 1;
      var index = currentIndex(track);
      if (control.hasAttribute('data-product-carousel-prev')) index -= 1;
      else if (control.hasAttribute('data-product-carousel-next')) index += 1;
      else {
        var dots = Array.prototype.slice.call(carousel.querySelectorAll('.ga-product__dot'));
        index = dots.indexOf(control);
      }
      if (index < 0) index = 0;
      if (index > max) index = max;
      scrollToIndex(carousel, index);
      // Reflect the target immediately so the dots/arrows never lag the scroll
      // event (which the scroll listener also handles once the scroll settles).
      syncControls(carousel, index);
    });

    // Brief button acknowledgement: label swaps to "Lisätty" and turns green
    // (via CSS), then reverts after ~1.5s. Under reduced motion the label
    // still swaps but no colour transition class is added.
    function acknowledgeAdd(button) {
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!button.dataset.originalLabel) button.dataset.originalLabel = button.textContent;
      button.textContent = button.dataset.addedLabel || button.dataset.originalLabel;
      if (!reduceMotion) button.classList.add('is-added');
      window.clearTimeout(button._gaAckTimeout);
      button._gaAckTimeout = window.setTimeout(function () {
        button.textContent = button.dataset.originalLabel;
        button.classList.remove('is-added');
      }, 1500);
    }

    // Add to cart / buy now via the AJAX Cart API. "Osta nyt" opens the cart
    // drawer immediately; "Lisää ostoskoriin" gives a quiet button
    // acknowledgement and a header cart-icon pulse, no drawer.
    document.addEventListener('click', function (e) {
      var button = e.target.closest('.ga-product__form [data-add-to-cart], .ga-product__form [data-buy-now]');
      if (!button || button.disabled) return;

      var form = button.closest('form');
      if (!form) return;
      e.preventDefault();

      var idField = form.querySelector('[name="id"]');
      var variantId = idField ? idField.value : null;
      if (!variantId) return;

      var isBuyNow = button.hasAttribute('data-buy-now');

      fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_add_url ? window.Shopify.routes.cart_add_url : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (response) {
          return response.json();
        })
        .then(function () {
          return fetch('/cart.js').then(function (response) {
            return response.json();
          });
        })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          if (isBuyNow) {
            document.dispatchEvent(new CustomEvent('cart:open', { detail: { cart: cart } }));
          } else {
            acknowledgeAdd(button);
            if (window.gaBumpCartIcon) window.gaBumpCartIcon();
          }
        })
        .catch(function () {});
    });
  })();

  // Accordion — accessible disclosure rows. Each trigger toggles aria-expanded
  // and an is-open class; the content animates between height 0 and its natural
  // height (measured from the inner wrapper, so it's exact). Under
  // prefers-reduced-motion it snaps open/closed with no transition. Rows are
  // independent: several can be open at once.
  (function () {
    var triggers = document.querySelectorAll('[data-accordion] .ga-accordion__trigger');
    triggers.forEach(function (trigger) {
      var panel = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!panel) return;
      var content = panel.querySelector('.ga-accordion__content');
      var inner = panel.querySelector('.ga-accordion__inner');
      if (!content || !inner) return;

      trigger.addEventListener('click', function () {
        var open = trigger.getAttribute('aria-expanded') !== 'true';
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.classList.toggle('is-open', open);

        // Always animate between two explicit pixel heights, forcing a reflow in
        // between so the transition has a start value to animate from. Under
        // prefers-reduced-motion the CSS defines no transition, so these simply
        // apply instantly. The height is measured from the inner wrapper, which
        // keeps its natural size regardless of the clipped content box.
        if (open) {
          content.style.height = '0px';
          content.getBoundingClientRect();
          content.style.height = inner.offsetHeight + 'px';
        } else {
          content.style.height = inner.offsetHeight + 'px';
          content.getBoundingClientRect();
          content.style.height = '0px';
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
